import React, { useRef, useEffect, useState } from "react"
import { ChevronDown, ChevronUp } from "lucide-react"
import { appTools, cn } from "lib/utils"

interface ISelectField {
  options:{ value:string, label:string }[]
  className?:string
  selectFn:Function
  defaultValue?:string
  valuePrefix?:string
  defaultLabel?:string
  value?:string
  error?:any 
  [key:string]:any
}

function SelectOption({ label, value, ...rest }:{ label:string, value:string; [key:string]:any }){ 
  return (
    <div 
      className="w-full h-8 flex justify-start items-center hover:bg-slate-800 px-2 cursor-pointer text-sm text-gray-200"
      {...rest}
    >
      {label}
    </div>
  )
}


export default function SelectField({ 
  options,
  children, 
  defaultValue,
  value,
  className, 
  defaultLabel="Choose...",
  valuePrefix="",
  selectFn,
  error=null,
  ...rest
}:ISelectField){

  const [ selectValue, setSelectValue ] = useState<string>( defaultValue ? defaultValue : value ? value : "" )
  const [ showOptions, setShowOptions ] = useState<boolean>(false)

  const selectRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if( selectValue ) selectFn(selectValue)
  },[selectValue])


  return (
    <div className="w-full relative">
      <input type="hidden" name={rest.name} value={selectValue} />
      <div 
        ref={selectRef}
        onClick={()=>setShowOptions(!showOptions)}
        className={cn(
          "w-full border border-solid border-slate-700 rounded-sm h-8 flex justify-between items-center bg-slate-900 outline-transparent outline outline-offset-2 text-sm text-gray-200 px-2 py-.5 cursor-pointer", 
          error && "outline-red-700",
          className
        )} 
        {...rest} 
      >
        { selectValue.length ? `${valuePrefix}${options.find((opt:any) => opt.value === selectValue)?.label}` : defaultLabel }
        { showOptions ? <ChevronDown className="w-4 h-4" /> : <ChevronUp className="w-4 h-4" /> }
      </div>
        { showOptions === true && (
          <div 
            className="absolute top-8 mt-[2px] left-0 flex flex-col justify-start items-start bg-slate-900 border border-solid border-slate-700 rounded-sm text-sm text-gray-200"
            style={{ width: selectRef?.current?.offsetWidth }}
          >
            { options.map((option, i) => (
              <SelectOption 
                key={option.value} 
                label={option.label} 
                value={option.value} 
                onClick={()=>{ 
                  setSelectValue(option.value)
                  setShowOptions(false)
                }} 
              />
            ))}
          </div>
        )}
    </div>
  )
}